const alertasInitialState = {
    alertas: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default alertasInitialState;
  